import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { Button } from "cxa-components";
import { CheckboxField } from "cxa-form-field";
import { isExist, compose } from "cxa-utils";
import StyledForm from "./StyledForm";
import { validateForm, validateRequired } from "./validation";
import { SUBMIT_FAILURE_MESSAGE } from "../constants";
import enhance from "../hoc";

const PRUDENTIAL_HDF_ID = "prudentialHdf";

const PrudentialHdf = props => {
  const {
    handleSubmit,
    submitting,
    confirm,
    prudentialForm,
    isReadOnly,
    renderValue,
    onSave,
    onPrint,
    onClose,
  } = props;

  const handleSave = onSave(PRUDENTIAL_HDF_ID);
  const isSubmitFailed = isExist(prudentialForm) && prudentialForm.submitFailed;

  return (
    <div className="hdf">
      <div className="aligner">
        <p className="aligner__item aligner__item--top">
          <img
            src="https://upload.wikimedia.org/wikipedia/en/9/97/Prudential_plc_logo.svg"
            className="logo"
            alt="Pudential HDF"
            width={150}
          />
        </p>
        <p
          className="aligner__item aligner__item--top"
          align="right"
          style={{ textAlign: "right" }}
        >
          Reg No 199002477Z
        </p>
      </div>
      <div className="aligner">
        <div className="aligner__item aligner__item--top">
          <h2>Group Health Declaration</h2>
          <ol className="ghd-list">
            <li>To be completed by the individual member in capital letter.</li>
            <li>
              All questions must be answered. Dashes, strokes, ditto and NA are not acceptable.
            </li>
            <li>Any alteration must be endorsed.</li>
          </ol>
        </div>
        <div className="aligner__item aligner__item--top">
          <table className="for-official-table" align="right" style={{ float: "right" }}>
            <tbody>
              <tr>
                <td colSpan={3}>FOR OFFICE USE ONLY</td>
              </tr>
              <tr>
                <td />
                <td>SA</td>
                <td>FCL</td>
              </tr>
              <tr>
                <td>GTL/TPD</td>
                <td />
                <td />
              </tr>
              <tr>
                <td>GCCA/GCCE</td>
                <td />
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <p className="border--default">
        WARNING: YOU ARE REQUIRED TO FULLY AND FAITHFULLY DISCLOSE ALL THE FACTS THAT YOU KNOW OR
        OUGHT TO KNOW. OTHERWISE, YOUR INSURANCE COVERAGE PROVIDED UNDER THIS PLAN MAY BE VOID.
      </p>

      <StyledForm renderValue={renderValue} />

      <div className="border--default">
        <p>
          <strong>
            Consent, Declaration and Authorisation - Please read carefully before signing this Group
            Health Declaration Form
          </strong>
        </p>
        <p>
          I/We consent to Prudential Assurance Company (Pte) Limited
          {'("Prudential")'}, its officers and employees:{" "}
        </p>
        <p className="subitem">
          a) Collecting and using at their sole discretion any and all information relating to
          me/us, including my/our personal particulars, in this Group Health Declaration for the
          purposes of underwriting; and
        </p>
        <p className="subitem">
          b) Disclosing at their sole discretion any and all information relating to me/us,
          including my/our personal particulars, in this Group Health Declaration to the servicing
          intermediary for the above group policy for the purpose of customer service.
        </p>
        <p>
          I/We declare that no material facts, that are facts likely to influence the assessment and
          acceptance of my/our group application, have been withheld and the information given above
          is true and complete and best to my/our knowledge and they shall be the basis of the
          issuance of my/our group insurance coverage.
        </p>
        <p>
          I/We agree and authorize any medical source (i.e. physician and hospital), insurance
          office or organization that has my/our records to release to Prudential any relevant
          information at any time for the purpose of underwriting this group application. A
          photographic copy of this authorization shall be as valid as the original.
        </p>
        <p>
          {[
            'I/We further declare that I/We have read and understood the "Your ',
            'Guide To Health Insurance" and "Product Summary" (applicable to ',
            "voluntary coverage only).",
          ].join("")}
        </p>

        <br />

        <CheckboxField validate={validateRequired} name="declaration" id="declaration">
          <strong>I have read and accept this declaration</strong>
        </CheckboxField>
      </div>
      <div className="signature">
        <div className="left">
          <p className="signature__field">Signature of Employee</p>
          <p className="signature__date">
            <br />
            Date:
          </p>
        </div>
        <div className="middle">
          <p className="signature__field">
            Signature of Spouse{" "}
            <sub>
              <i>(if applicable)</i>
            </sub>
          </p>
          <p className="signature__date">
            <br />
            Date:
          </p>
        </div>
        <div className="right">
          <p className="signature__field">
            Signature/Name/Designation of <strong>Witness (Employer)</strong>
          </p>
          <p className="signature__date">Date:</p>
        </div>
      </div>
      <div>
        <p className="text--center">
          <strong>Prudential Assurance Company Singapore (Pte) Limited (Reg. No 199002477Z)</strong>
          <br />
          Employee Benefit Solutions Address: Singapore Post Centre Post Office PO Box 399 Singapore
          914014
          <br />
          Email:{" "}
          <a href="mailto:sgp.employeebenefitsolutions.billing@prudential.com.sg">
            sgp.employeebenefitsolutions.billing@prudential.com.sg
          </a>{" "}
          Fax: 6233-3285
        </p>
        <p className="text--left">EBS HD Nov 2015</p>
      </div>

      {isSubmitFailed && (
        <p role="alert" className="card--alert">
          {SUBMIT_FAILURE_MESSAGE}
        </p>
      )}

      <div className="form__actions">
        {!isReadOnly ? (
          [
            <Button key="save" onClick={handleSave} disabled={submitting} secondary>
              Save
            </Button>,
            <Button
              primary
              key="submit"
              submitting={submitting}
              onClick={handleSubmit(confirm)}
              disabled={submitting}
            >
              Submit & Confirm
            </Button>,
          ]
        ) : (
          <Button primary onClick={onPrint}>Print</Button>
        )}

        <Button onClick={onClose} disabled={submitting} secondary>
          Close
        </Button>
      </div>
    </div>
  );
};

PrudentialHdf.propTypes = {
  employeeParticulars: PropTypes.object,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  save: PropTypes.func,
  confirm: PropTypes.func,
  prudentialForm: PropTypes.object,
  isReadOnly: PropTypes.bool,
  renderValue: PropTypes.func,
  onSave: PropTypes.func,
  onPrint: PropTypes.func,
  onClose: PropTypes.func,
};

export default compose(
  enhance,
  reduxForm({
    form: PRUDENTIAL_HDF_ID,
    enableReinitialize: true,
    validate: validateForm,
  })
)(PrudentialHdf);



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Prudential/form.js